import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactTooltip from 'react-tooltip';
import useTranslation from '../../../../hooks/useTranslation';
import FilterIcon from '../../../../assets/img/outcomes.svg';
import InfoBlue from '../../../../assets/img/info-blue.svg';

const lang = new URLSearchParams(window.location.search).get('lang') || 'en';
// import NewTag from '../../../../assets/img/new_tag.svg';

const Outcome = (props) => {
  const { t } = useTranslation();
  const {
    classes, filters, isLoading, checkedListAll, handleOutcomeFiltersTest,
  } = props;

  const [open, setOpen] = useState(!!(checkedListAll && checkedListAll.length > 0));

  const handleClick = () => {
    setOpen(!open);
  };

  const renderOutcome = (outcomes) => outcomes.map((info) => {
    let checked = false;
    let list = '';
    if (checkedListAll && checkedListAll.indexOf(info.key) > -1) {
      checked = true;
    }
    if (info.key !== '') {
      list = (
        <ListItem button className={classes.nested} key={info.key}>
          <ListItemText className={classes.filterItem}>
            <FormControlLabel
              className={classes.checkBox}
              control={(
                <Checkbox
                  value={info.key}
                  classes={{
                    root: classes.checkBox,
                    checked: classes.checked,
                  }}
                  checked={checked}
                  onClick={!isLoading && handleOutcomeFiltersTest}
                  disabled={isLoading}
                  disableRipple
                />
                    )}
              label={`${info.key} (${info.doc_count})`}
            />
          </ListItemText>
        </ListItem>
      );
    }
    return list;
  });

  return (
    <List className={classes.filterMenu}>
      <ListItem button onClick={handleClick} className={classes.filterHead}>
        <ListItemText>
          <div className={classes.SVG__Filter}>
            <img src={FilterIcon} alt="" />
            &nbsp;
            {t('filterOutcomes')}
            <img data-for="outcomeInfo" data-event="click focus mouseover" data-tip className={classes.infoIcon} src={InfoBlue} alt="" />
            <ReactTooltip id="outcomeInfo" className={classNames(classes.reactTooltip, classes.reactTooltipClickableLink)} globalEventOff="mouseover" place="right" type="light" effect="solid">
              <span>
                {t('tooltipOutcome')}
                <Link to={`/taxonomy-search?lang=${lang}`}>
                  {' '}
                  {t('here')}
                </Link>
                {t('tooltipOutcomeEnd')}
              </span>
            </ReactTooltip>
          </div>
        </ListItemText>
        {
          open ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.filterMenuBlock}>
        <div className={classes.maxHeightScroll}>
          <Scrollbars autoHeight>
            <List component="div" disablePadding>
              {
            filters
              ? (
                renderOutcome(filters)
              )
              : (
                <span className={classes.noFiltersFound}>
                  {t('noFiltersFor')}
                  {' '}
                  {t('filterOutcomes')}
                </span>
              )
          }
            </List>
          </Scrollbars>
        </div>
      </Collapse>
    </List>
  );
};

Outcome.defaultProps = {
  filters: null,
  isLoading: false,
  checkedListAll: null,
};

Outcome.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.object),
  handleOutcomeFiltersTest: PropTypes.func.isRequired,
  checkedListAll: PropTypes.arrayOf(PropTypes.string),
};

export default Outcome;
